import { Redirect, useRoute } from "wouter";

export default function LegalDoc() {
  const [, params] = useRoute("/legal/:kind");
  const kind = params?.kind ?? "terms";
  return <Redirect to={`/legal?document=${encodeURIComponent(kind)}`} replace />;
}
